/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import ArrowBackIos from '@mui/icons-material/ArrowBackIos'
import {
  Box,
  Breadcrumbs,
  CardContent,
  CircularProgress,
  Grid,
  Link,
  TextField,
  Typography
} from '@mui/material'
import LanguageStrings from '../../../../i18n/locales'
import React from 'react'
import { GenXDropdown, type Option } from '../../../../components/GenXDropdown'
import { Button } from '../../../../components/Button'
import { useNavigate } from 'react-router-dom'
import { CreateSFTPConfigurationservice, getConfigurationDropdownMetadata } from '../../redux/actionCreators'
import { type CreateSFTPConfigurationState } from '../../redux/CreateSftpConfigurationSlice'
import { type ConfigurationMetadataDropDownState } from '../../redux/configurationMetaDataSlice'
import { type ConnectedProps, connect, useSelector } from 'react-redux'
import { type RootState } from '../../../../store'
import { type SFTPConfigurationData } from '../../types'
import Modal from '../../../../components/Modal'
import AuthError from '../../../../components/ErrorComponents/AuthError'
import '../ReportSchedulerComponents/scheduler.css'
import { isValidName, isValidPort } from '../../../../utils/validator'
import { isValidIp } from '../../../data-publisher/components/addConfig/fileValidation'

const CreateSFTPStrings = LanguageStrings().AMIDataCollectionStrings.ConfigurationUploadStrings.SchedulerStrings.CreateSFTPFormStrings

const CreateSFTPButtonStrings = LanguageStrings().AMIDataCollectionStrings.ConfigurationUploadStrings.SchedulerStrings.CreateSchedulerFormStrings

const style = {
  width: '99%',
  borderRadius: '10px',
  border: '1px solid #101010',
  background: '#272727',
  boxShadow: '1px 1px 1px 0px rgba(0, 0, 0, 0.15)',
  fontSize: '16px',
  marginBottom: '16px',
  padding: '24px'
}

const CreateSftpConfiguration = (props: PropsFromRedux): JSX.Element => {
  const navigate = useNavigate()
  const [protocolSpecificationName, setProtocolSpecificationName] = React.useState('')
  const [description, setDescription] = React.useState('')
  const [selectProtocol, setselectProtocol] = React.useState<Option | null>(null)
  const [selectProtocolOptions, setSelectProtocolOptions] = React.useState<Option[]>([])
  const [protocolName, setProtocolName] = React.useState('')
  const [ipAddress, setIpAddress] = React.useState('')
  const [port, setPort] = React.useState('')
  const [userName, setUserName] = React.useState('')
  const [password, setpassword] = React.useState('')
  const [confirm, setconfirm] = React.useState(false)
  const [showSuccessPopUp, setshowSuccessPopUp] = React.useState(false)
  const [reqError, setReqError] = React.useState<boolean>(false)
  const DropDownMetaData = useSelector((state: RootState) => state?.ConfigurationMetadata?.configurationMetadata?.protocols)
  const ProocolHttpStatus = useSelector((state: RootState) => state?.SFTPConfigurationData)

  const initialState = {
    configurationName: null,
    description: null,
    protocolTypeId: null,
    protocolName: null,
    ipAddress: null,
    port: null,
    userName: null,
    password: null
  }

  const [addState, dispatch] = React.useReducer(
    (curVal: any, newVal: any) => ({ ...curVal, ...newVal }),
    initialState
  )

  React.useEffect(() => {
    props.getConfigurationDropdownMetadata()
  }, [])

  React.useEffect(() => {
    if (DropDownMetaData !== undefined && DropDownMetaData?.length > 0) {
      const ProtocolOption: Option[] = []
      DropDownMetaData?.forEach((item: any) => {
        ProtocolOption.push({
          value: item.protocolTypeId,
          label: item.protocolTypeName
        })
      })
      setSelectProtocolOptions(ProtocolOption)
    }
  }, [DropDownMetaData])

  const handleConfigurationName = (name: string, value: string): void => {
    setProtocolSpecificationName(value)
    dispatch({ ...addState, configurationName: value })
  }

  const handleDescription = (name: string, value: string): void => {
    setDescription(value)
    dispatch({ ...addState, description: value })
  }

  const handleProtocol = (selectedValue: Option): void => {
    setselectProtocol(selectedValue)
    dispatch({ ...addState, protocolTypeId: selectedValue.value })
  }

  const handleProtocolName = (name: string, value: string): void => {
    setProtocolName(value)
    dispatch({ ...addState, protocolName: value })
  }

  const handleIPAddress = (name: string, value: string): void => {
    setIpAddress(value)
    dispatch({ ...addState, ipAddress: value })
  }

  const handlePortNumber = (name: string, value: string): void => {
    setPort(value)
    dispatch({ ...addState, port: value })
  }

  const handleUserName = (name: string, value: string): void => {
    setUserName(value)
    dispatch({ ...addState, userName: value })
  }

  const handlePassword = (name: string, value: string): void => {
    setpassword(value)
    dispatch({ ...addState, password: value })
  }

  const handleOkandClose = (): void => {
    setshowSuccessPopUp(false)
    setconfirm(false)
    navigate('/configuration-protocol')
    clearAllDetails()
  }

  const clearAllDetails = (): void => {
    setProtocolSpecificationName('')
    setDescription('')
    setselectProtocol(null)
    setProtocolName('')
    setIpAddress('')
    setPort('')
    setUserName('')
    setpassword('')
  }

  const isValidlength = (value: string): boolean => {
    return value.length > 5 && value.length < 100
  }

  const isValidPasswordlength = (value: string): boolean => {
    return value.length > 8 && value.length < 15
  }

  const handleconfirmClick = (): void => {
    props.CreateSFTPConfigurationservice(addState)
    setconfirm(false)
    setshowSuccessPopUp(true)
  }

  const handleCreateConfigurationWithFailure = (): JSX.Element => {
    // istanbul ignore else
    if (ProocolHttpStatus.httpStatus === 201) {
      return (
        <Modal
          buttonTypeNegative="hollow"
          title={CreateSFTPStrings.CreateTitle}
          LabelPositive={'Ok'}
          onClickPositive={() => {
            handleOkandClose()
          }}
          onClose={() => {
            handleOkandClose()
          }}
        >
          <p style={{ paddingTop: '1.2em' }}>
            {ProocolHttpStatus.httpStatus === 201
              ? CreateSFTPStrings.SucessfullyCreated
              : ProocolHttpStatus.error}
          </p>
        </Modal>
      )
    } else if (ProocolHttpStatus.isLoading) {
      return (
        <Modal title={'Loding...'}>
          <div className="CircularprogressAmi">
            <CircularProgress />
          </div>
        </Modal>
      )
    } else if (ProocolHttpStatus.httpStatus === 400) {
      return (
        <Modal
          buttonTypeNegative="hollow"
          title={'Error'}
          LabelPositive={'Ok'}
          onClickPositive={() => {
            handleOkandClose()
          }}
          onClose={() => {
            handleOkandClose()
          }}
        >
          <p style={{ paddingTop: '1.2em' }}>{ProocolHttpStatus.error}</p>
        </Modal>
      )
    } else if (ProocolHttpStatus.httpStatus === 401) {
      return (
        <div className="authError">
          <AuthError errorMessage="Unauthorized" />
        </div>
      )
    } else if (ProocolHttpStatus.httpStatus === 403) {
      return (
        <div className="authError">
          <AuthError errorMessage="accessForbidden" />
        </div>
      )
    } else {
      return (
        <Modal
          buttonTypeNegative="hollow"
          title={CreateSFTPStrings.CreateTitle}
          LabelPositive={'ok'}
          onClickPositive={() => {
            setshowSuccessPopUp(false)
            setconfirm(false)
            navigate('/configuration-protocol')
          }}
          onClose={() => {
            setshowSuccessPopUp(false)
            setconfirm(false)
            navigate('/configuration-protocol')
          }}
        >
          <p style={{ paddingTop: '1.2em' }}>{ProocolHttpStatus.error}</p>
        </Modal>
      )
    }
  }

  const validateFields = (): void => {
    if (
      addState.configurationName !== null &&
      addState.description !== null &&
      addState.protocolTypeId !== null &&
      addState.protocolName !== null &&
      addState.ipAddress !== null &&
      addState.port !== null &&
      addState.userName !== null &&
      addState.password !== null
    ) {
      if (addState.configurationName) {
        if (!isValidName(addState.configurationName)) {
          setReqError(true)
          return
        }
      }
      if (addState.configurationName) {
        if (!isValidlength(addState.configurationName)) {
          setReqError(true)
          return
        }
      }
      if (addState.description) {
        if (!isValidName(addState.description)) {
          setReqError(true)
          return
        }
      }
      if (addState.description) {
        if (!isValidlength(addState.description)) {
          setReqError(true)
          return
        }
      }
      if (addState.protocolName) {
        if (!isValidName(addState.protocolName)) {
          setReqError(true)
          return
        }
      }
      if (addState.protocolName) {
        if (!isValidlength(addState.protocolName)) {
          setReqError(true)
          return
        }
      }
      if (addState.ipAddress) {
        if (!isValidIp(addState.ipAddress)) {
          setReqError(true)
          return
        }
      }
      if (addState.port) {
        if (!isValidPort(addState.port)) {
          setReqError(true)
          return
        }
      }
      if (addState.port) {
        if (!isValidPort(addState.port)) {
          setReqError(true)
          return
        }
      }
      if (addState.userName) {
        if (!isValidName(addState.userName)) {
          setReqError(true)
          return
        }
      }
      if (addState.userName) {
        if (!isValidlength(addState.userName)) {
          setReqError(true)
          return
        }
      }
      if (addState.password) {
        if (!isValidPasswordlength(addState.password)) {
          setReqError(true)
          return
        }
      }
      setconfirm(true)
    } else {
      setReqError(true)
    }
  }

  return (
    <>
      <div
        role="presentation"
        data-testid="breadcrumbs"
        style={{ width: '100%' }}
      >
        <Breadcrumbs
          aria-name="breadcrumb"
          sx={{
            color: '#f0f0f0',
            fontSize: '12px',
            marginBottom: '14px',
            fontFamily: 'Honeywell Sans Web',
            marginTop: '12px'
          }}
        >
          <Link
            underline="hover"
            color="inherit"
            data-testid="scheduler-breadcrumb"
            onClick={() => {
              navigate('/datapub')
            }}
          >
            {CreateSFTPStrings.dataPublisherSettings}
          </Link>
          <Link
            underline="hover"
            color="inherit"
            sx={{ fontSize: '12px', fontFamily: 'Honeywell Sans Web' }}
            onClick={() => {
              navigate('/configuration-protocol')
            }}
          >
            {CreateSFTPStrings.configurationProtocol}
          </Link>
          <Typography
            color="inherit"
            sx={{ fontSize: '12px', fontFamily: 'Honeywell Sans Web' }}
          >
            {CreateSFTPStrings.addConfigurationProtocol}
          </Typography>
        </Breadcrumbs>
      </div>
      <div style={{ display: 'flex' }}>
        <ArrowBackIos
          sx={{ cursor: 'pointer' }}
          data-testid="back-arrow"
            onClick={() => {
              navigate('/configuration-protocol')
            }}
        />
        <div style={{ marginBottom: '32px' }}>
          <span
            data-testid="schedule-title"
            style={{
              color: '#f0f0f0',
              fontSize: '24px',
              fontWeight: '900',
              paddingRight: '16px',
              marginRight: '10px'
            }}
          >
            {CreateSFTPStrings.addConfigurationProtocol}
          </span>
        </div>
      </div>
      <Box sx={style} className="add-Scheduler-container">
        <Typography
          color="inherit"
          sx={{
            fontSize: '16px',
            textTransform: 'uppercase',
            fontWeight: '800',
            fontFamily: 'Honeywell Sans Web'
          }}
        >
          {CreateSFTPStrings.configurationSpecifications}
        </Typography>
        <CardContent>
          <Grid container spacing={1}>
            <Grid item md={3}>
              <span style={{ fontSize: '15px', padding: 10, display: 'block' }}>
                {CreateSFTPStrings.name}
                <sup style={{ color: '#EE3426' }}>*</sup>
              </span>
              <TextField
                id="configuration-name"
                variant="outlined"
                data-testId="configuration-name"
                placeholder="Enter Configuration Name"
                InputLabelProps={{
                  disabled: true
                }}
                value={protocolSpecificationName}
                onChange={(e) => {
                  handleConfigurationName('configurationName', e.target.value)
                }}
                size="small"
                autoComplete="off"
                className="configuration-name-class"
                sx={{
                  width: '270px',
                  color: '#fffff !important'
                }}
              />
              {addState.configurationName !== null && !isValidName(addState.configurationName) && (
                <div className='error-response'>
                  <span className='error-upload-message'>
                    {CreateSFTPButtonStrings.enterValidText}
                  </span>
                </div>
              )}
              {reqError && !addState.configurationName && (
                <div className='error-response'>
                  <span className='error-upload-message'>{CreateSFTPButtonStrings.required}</span>
                </div>
              )}
              {addState.configurationName !== null && !isValidlength(addState.configurationName) && (
                <div className='error-response'>
                  <span className='error-upload-message'>
                    {CreateSFTPButtonStrings.enterMoreText}
                  </span>
                </div>
              )}
            </Grid>
            <Grid item md={3}>
              <span style={{ fontSize: '15px', padding: 10, display: 'block' }}>
                {CreateSFTPStrings.description}
                <sup style={{ color: '#EE3426' }}>*</sup>
              </span>
              <TextField
                id="configuration-desc"
                variant="outlined"
                data-testId="configuration-desc"
                placeholder="Enter Description"
                InputLabelProps={{
                  disabled: true
                }}
                value={description}
                onChange={(e) => {
                  handleDescription('description', e.target.value)
                }}
                size="small"
                autoComplete="off"
                className="configuration-name-class"
                sx={{
                  width: '270px',
                  color: '#fffff !important'
                }}
              />
              {reqError && !addState.description && (
                <div className='error-response'>
                  <span className='error-upload-message'>{CreateSFTPButtonStrings.required}</span>
                </div>
              )}
              {addState.description !== null && !isValidlength(addState.description) && (
                <div className='error-response'>
                  <span className='error-upload-message'>
                    {CreateSFTPButtonStrings.enterMoreText}
                  </span>
                </div>
              )}
            </Grid>
          </Grid>
        </CardContent>
      </Box>
      <Box sx={style} className="add-Scheduler-container">
        <Typography
          color="inherit"
          sx={{
            fontSize: '16px',
            textTransform: 'uppercase',
            fontWeight: '800',
            fontFamily: 'Honeywell Sans Web'
          }}
        >
          {CreateSFTPStrings.connectionSettings}
        </Typography>
        <CardContent>
          <Grid container spacing={1}>
            <Grid item md={3}>
              <span style={{ fontSize: '15px', padding: 10, display: 'block' }}>
                {CreateSFTPStrings.protocol}
                <sup style={{ color: '#EE3426' }}>*</sup>
              </span>
              <GenXDropdown
                placeholder="Select Protocol"
                value={selectProtocol}
                options={selectProtocolOptions}
                onSelect={handleProtocol}
                width={270}
              />
              {reqError && !addState.protocolTypeId && (
                <div className='error-response'>
                  <span className='error-upload-message'>{CreateSFTPButtonStrings.required}</span>
                </div>
              )}
            </Grid>
            <Grid item md={3}>
              <span style={{ fontSize: '15px', padding: 10, display: 'block' }}>
                {CreateSFTPStrings.protocolName}
                <sup style={{ color: '#EE3426' }}>*</sup>
              </span>
              <TextField
                id="configuration-Pname"
                variant="outlined"
                data-testId="configuration-Pname"
                placeholder="Enter Protocol Name"
                InputLabelProps={{
                  disabled: true
                }}
                value={protocolName}
                onChange={(e) => {
                  handleProtocolName('protocolName', e.target.value)
                }}
                size="small"
                autoComplete="off"
                className="configuration-name-class"
                sx={{
                  width: '270px',
                  color: '#fffff !important'
                }}
              />
              {addState.protocolName !== null && !isValidName(addState.protocolName) && (
                <div className='error-response'>
                  <span className='error-upload-message'>
                    {CreateSFTPButtonStrings.enterValidText}
                  </span>
                </div>
              )}
              {reqError && !addState.protocolName && (
                <div className='error-response'>
                  <span className='error-upload-message'>{CreateSFTPButtonStrings.required}</span>
                </div>
              )}
              {addState.protocolName !== null && !isValidlength(addState.protocolName) && (
                <div className='error-response'>
                  <span className='error-upload-message'>
                    {CreateSFTPButtonStrings.enterMoreText}
                  </span>
                </div>
              )}
            </Grid>
            <Grid item md={3}>
              <span style={{ fontSize: '15px', padding: 10, display: 'block' }}>
                {CreateSFTPStrings.SFTPIPAddress}
                <sup style={{ color: '#EE3426' }}>*</sup>
              </span>
              <TextField
                id="configuration-Ip"
                variant="outlined"
                data-testId="configuration-Ip"
                placeholder="Enter IP Address"
                InputLabelProps={{
                  disabled: true
                }}
                value={ipAddress}
                onChange={(e) => {
                  handleIPAddress('ipAddress', e.target.value)
                }}
                size="small"
                autoComplete="off"
                className="configuration-name-class"
                sx={{
                  width: '270px',
                  color: '#fffff !important'
                }}
              />
              {reqError && !addState.ipAddress && (
                <div className='error-response'>
                  <span className='error-upload-message'>{CreateSFTPButtonStrings.required}</span>
                </div>
              )}
              {addState.ipAddress !== null && !isValidIp(addState.ipAddress) && (
                <div className='error-response'>
                  <span className='error-upload-message'>
                    {CreateSFTPStrings.ValidIP}
                  </span>
                </div>
              )}
            </Grid>
            <Grid item md={3}>
              <span style={{ fontSize: '15px', padding: 10, display: 'block' }}>
                {CreateSFTPStrings.SFTPPort}
                <sup style={{ color: '#EE3426' }}>*</sup>
              </span>
              <TextField
                id="configuration-port"
                variant="outlined"
                data-testId="configuration-port"
                placeholder="Enter Port"
                InputLabelProps={{
                  disabled: true
                }}
                inputProps={{ maxLength: 5 }}
                value={port}
                onChange={(e) => {
                  handlePortNumber('port', e.target.value)
                }}
                size="small"
                autoComplete="off"
                className="configuration-name-class"
                sx={{
                  width: '270px',
                  color: '#fffff !important'
                }}
              />
              {reqError && !addState.port && (
                <div className='error-response'>
                  <span className='error-upload-message'>{CreateSFTPButtonStrings.required}</span>
                </div>
              )}
              {addState.port !== null && !isValidPort(addState.port) && (
                <div className='error-response'>
                  <span className='error-upload-message'>
                    {CreateSFTPStrings.ValidPort}
                  </span>
                </div>
              )}
            </Grid>
            <Grid item md={3}>
              <span style={{ fontSize: '15px', padding: 10, display: 'block' }}>
                {CreateSFTPStrings.username}
                <sup style={{ color: '#EE3426' }}>*</sup>
              </span>
              <TextField
                id="configuration-username"
                variant="outlined"
                data-testId="configuration-username"
                placeholder="Enter Username"
                InputLabelProps={{
                  disabled: true
                }}
                value={userName}
                onChange={(e) => {
                  handleUserName('userName', e.target.value)
                }}
                size="small"
                autoComplete="off"
                className="configuration-name-class"
                sx={{
                  width: '270px',
                  color: '#fffff !important'
                }}
              />
              {reqError && !addState.userName && (
                <div className='error-response'>
                  <span className='error-upload-message'>{CreateSFTPButtonStrings.required}</span>
                </div>
              )}
              {addState.userName !== null && !isValidlength(addState.userName) && (
                <div className='error-response'>
                  <span className='error-upload-message'>
                  {CreateSFTPButtonStrings.enterMoreText}
                  </span>
                </div>
              )}
            </Grid>
            <Grid item md={3}>
              <span style={{ fontSize: '15px', padding: 10, display: 'block' }}>
                {CreateSFTPStrings.password}
                <sup style={{ color: '#EE3426' }}>*</sup>
              </span>
              <TextField
                id="configuration-password"
                variant="outlined"
                data-testId="configuration-password"
                placeholder="Enter Password"
                type="password"
                InputLabelProps={{
                  disabled: true
                }}
                value={password}
                onChange={(e) => {
                  handlePassword('password', e.target.value)
                }}
                size="small"
                autoComplete="off"
                className="configuration-name-class"
                sx={{
                  width: '270px',
                  color: '#fffff !important'
                }}
              />
              {reqError && !addState.password && (
                <div className='error-response'>
                  <span className='error-upload-message'>{CreateSFTPButtonStrings.required}</span>
                </div>
              )}
              {addState.password !== null && !isValidPasswordlength(addState.password) && (
                <div className='error-response'>
                  <span className='error-upload-message'>
                  {CreateSFTPStrings.PasswordError}
                  </span>
                </div>
              )}
            </Grid>
          </Grid>
        </CardContent>
      </Box>
      <Box sx={style} className="add-configuration-container">
        <Grid container spacing={1}>
          <Grid style={{ textAlign: 'left' }} item md={6}>
            <Button
              type="hollow"
              data-testid="cancel-btn"
              onClick={() => {
                navigate('/configuration-dashboard')
                clearAllDetails()
              }}
            >
              {CreateSFTPButtonStrings.CancelBtn}
            </Button>
          </Grid>
          <Grid style={{ textAlign: 'right' }} item md={6}>
            <Button
              onClick={() => {
                validateFields()
              }}
            >
              {CreateSFTPButtonStrings.CreateBtn}
            </Button>
          </Grid>
        </Grid>
      </Box>

      {confirm && (
        <Modal
          titleStyle={{ paddingRight: '2em', marginBottom: '20px' }}
          buttonTypeNegative="hollow"
          LabelPositive={CreateSFTPButtonStrings.ConfirmBtn}
          LabelNegative={CreateSFTPButtonStrings.CancelBtn}
          onClickPositive={() => {
            handleconfirmClick()
          }}
          onClose={() => {
            setconfirm(false)
          }}
          onClickNegative={() => {
            setconfirm(false)
          }}
          title={'Create Protocol Configuration'}
        >
          <div className="confirm-msg" style={{ marginBottom: '30px' }}>
            <span>{CreateSFTPStrings.CreateConfirm}</span>
          </div>
        </Modal>
      )}
      {showSuccessPopUp && handleCreateConfigurationWithFailure()}
    </>
  )
}

interface DispatchToProps {
  CreateSFTPConfigurationservice: (
    createReportSchedulerTemplatePostRequest: SFTPConfigurationData
  ) => void
  getConfigurationDropdownMetadata: () => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  CreateSFTPConfigurationservice: (
    createReportSchedulerTemplatePostRequest: SFTPConfigurationData
  ) =>
    dispatch(
      CreateSFTPConfigurationservice(createReportSchedulerTemplatePostRequest)
    ),
  getConfigurationDropdownMetadata: () =>
    dispatch(getConfigurationDropdownMetadata())
})

interface StateToProps {
  SFTPConfigurationData: CreateSFTPConfigurationState
  ConfigurationMetadata: ConfigurationMetadataDropDownState
}

const mapStateToProps = (state: RootState): StateToProps => ({
  SFTPConfigurationData: state.SFTPConfigurationData,
  ConfigurationMetadata: state.ConfigurationMetadata
})

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(CreateSftpConfiguration)
